import React, { useState } from 'react';
import { ConfigProvider } from 'antd';
import { customDefaultTheme, customDarkTheme } from './themes/customTheme'
import RouterApp from './routes';
import '../src/App.scss';
import { RefreshProvider } from './RefreshContext';
import { setupAxiosSubscriptionInterceptor } from './setupAxiosSubscriptionInterceptor';
import ErrorBoundary from './components/ErrorBoundary';

setupAxiosSubscriptionInterceptor();

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <RefreshProvider>
      <ConfigProvider theme={isDarkMode ? customDarkTheme : customDefaultTheme}>
        <ErrorBoundary>
          <RouterApp isDarkMode={isDarkMode} toggleTheme={toggleTheme}/>
        </ErrorBoundary>
      </ConfigProvider>
    </RefreshProvider>
  );
}

export default App;
